import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/homepage-single-page-application/components/HomepageInteractive.tsx");
